import {createRouter, createWebHistory} from 'vue-router'
import ColorPalettes from "./ColorPalettes.vue";
import ColorsHome from "./ColorsHome.vue";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/colors',
            redirect: '/colors/home',
        },
        {
            path: '/colors/home',
            name: 'home',
            component: ColorsHome,
        },
        {
            path: '/colors/palettes',
            name: 'palettes',
            component: ColorPalettes
        }
    ]
})

export default router